// extracted by mini-css-extract-plugin
export var blogContainer = "blog-module--blogContainer--21a3d";
export var date = "blog-module--date--00547";
export var headline = "blog-module--headline--ff514";